import React from "react";
import PropTypes from "prop-types";

const SimpleLegend = ({ data, legendItems }) => {
  const cleanLegendItems = legendItems.filter((item) => !item.legendExclude);
  return (
    <div className="simple-legend__container">
      {cleanLegendItems.map((item) => {
        const { label, accessor, fill } = item;
        return (
          <div className="simple-legend__row" key={accessor}>
            <div className="simple-legend__item">
              <ColorBlock fill={fill} />
              <span className="simple-legend__item-label">{label}</span>
            </div>
            <div className="simple-legend__value">{data[accessor]}</div>
          </div>
        );
      })}
    </div>
  );
};

SimpleLegend.propTypes = {
  data: PropTypes.objectOf(PropTypes.any).isRequired,
  legendItems: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      accessor: PropTypes.string,
      fill: PropTypes.string,
    })
  ).isRequired,
};

const ColorBlock = ({ size, fill }) => (
  <div style={{ backgroundColor: fill, width: size, height: size }} />
);

ColorBlock.defaultProps = {
  size: 10,
};

ColorBlock.propTypes = {
  fill: PropTypes.string.isRequired,
  size: PropTypes.number,
};

export default SimpleLegend;
